import './App.css';
import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import HomePage from './HomePage';
import BlogsPage from './Pages/BlogsPage';
import BlogPostPage from './Pages/BlogPostPage';
import { LanguageProvider } from './context/LanguageContext';
import LanguageToggle from './components/LanguageToggle';
import ContactPage from './Pages/ContactPage ';
import PrivacyPolicyPage from './Pages/PrivacyPolicyPage';
import TermsAndConditions from './Pages/TermsAndConditions';
import Copyright from './Pages/Copyright';


// SEO Component
const SEO = ({ title, description, keywords, image, url }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
    </Helmet>
  );
};

// Scroll to top on route change
function ScrollToTopOnMount() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <ScrollToTopOnMount />
        
        {/* Language Toggle - Shows on ALL pages */}
        {/* <LanguageToggle /> */}
        
        <Routes>
          <Route 
            path="/" 
            element={
              <>
                <SEO 
                  title="Shree Digital Solutions And Services E-Seva Kendra - Government Services in Thane"
                  description="Complete assistance for government forms, online registrations, document services. Aadhar, PAN, Passport, Driving License and more. Fast, reliable service in Thane."
                  keywords="e-seva kendra, government services, aadhar card, pan card, passport, driving license, thane, maharashtra, online services"
                  image="https://shreeservz.com/og-image.jpg"
                  url="https://shreeservz.com/"
                />
                <HomePage />
              </>
            } 
          />
          
          <Route 
            path="/blogs" 
            element={
              <>
                <SEO 
                  title="Blogs & Articles - Shree Digital Solutions And Services E-Seva Kendra"
                  description="Read latest updates, guides and information about government services, documents, and schemes. Stay informed with our knowledge hub."
                  keywords="government schemes, how-to guides, document help, success stories, e-seva articles"
                  image="https://shreeservz.com/blogs-og-image.jpg"
                  url="https://shreeservz.com/blogs/"
                />
                <BlogsPage />
              </>
            } 
          />
          
          {/* BlogPostPage handles its own SEO internally with dynamic data */}
          <Route 
            path="/blogs/:slug" 
            element={<BlogPostPage />}
          />

          <Route 
            path="/contact" 
            element={
              <>
                <SEO 
                  title="Contact Us - Shree Digital Solutions And Services E-Seva Kendra"
                  description="Get in touch with us for any queries about government services, documents, or assistance. We're here to help you."
                  keywords="contact, e-seva kendra contact, government services help, thane contact"
                  image="https://shreeservz.com/contact-og-image.jpg"
                  url="https://shreeservz.com/contact"
                />
                <ContactPage />
              </>
            } 
          />
          
          {/* <Route 
            path="/privacy-policy" 
            element={
              <>
                <SEO 
                  title="Privacy Policy - Shree Digital Solutions And Services E-Seva Kendra"
                  description="Learn about how we protect your privacy and handle your personal information at Shree Digital Solutions And Services E-Seva Kendra."
                  keywords="privacy policy, data protection, personal information, e-seva kendra privacy"
                  image="https://shreeservz.com/privacy-og-image.jpg"
                  url="https://shreeservz.com/privacy-policy"
                />
                <PrivacyPolicyPage />
              </>
            } 
          /> */}
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/copyright" element={<Copyright />} />

           {/* <Route 
            path="/terms-and-conditions" 
            element={
              <>
                <SEO 
                  title="Privacy Policy - Shree Digital Solutions And Services E-Seva Kendra"
                  description="Learn about how we protect your privacy and handle your personal information at Shree Digital Solutions And Services E-Seva Kendra."
                  keywords="privacy policy, data protection, personal information, e-seva kendra privacy"
                  image="https://shreeservz.com/privacy-og-image.jpg"
                  url="https://shreeservz.com/privacy-policy"
                />
                <TermsAndConditions />
              </>
            } 
          /> */}
        </Routes>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;